import { Language } from "@/i18n/translations";

// Platform name translations
export const platformNames: Record<string, Record<Language, string>> = {
  instagram: { he: "אינסטגרם", en: "Instagram", ru: "Инстаграм" },
  facebook: { he: "פייסבוק", en: "Facebook", ru: "Фейсбук" },
  youtube: { he: "יוטיוב", en: "YouTube", ru: "Ютуб" },
  telegram: { he: "טלגרם", en: "Telegram", ru: "Телеграм" },
  tiktok: { he: "טיקטוק", en: "TikTok", ru: "ТикТок" },
  twitter: { he: "טוויטר / X", en: "Twitter / X", ru: "Твиттер / X" },
  spotify: { he: "ספוטיפיי", en: "Spotify", ru: "Спотифай" },
  soundcloud: { he: "סאונדקלאוד", en: "SoundCloud", ru: "SoundCloud" },
  twitch: { he: "טוויץ׳", en: "Twitch", ru: "Твич" },
  discord: { he: "דיסקורד", en: "Discord", ru: "Дискорд" },
  linkedin: { he: "לינקדאין", en: "LinkedIn", ru: "Линкедин" },
  reddit: { he: "רדיט", en: "Reddit", ru: "Реддит" },
  clubhouse: { he: "קלאבהאוס", en: "Clubhouse", ru: "Клабхаус" },
  snapchat: { he: "סנאפצ'ט", en: "Snapchat", ru: "Снэпчат" },
  threads: { he: "ת'רדס", en: "Threads", ru: "Threads" },
  pinterest: { he: "פינטרסט", en: "Pinterest", ru: "Пинтерест" },
  likee: { he: "לייקי", en: "Likee", ru: "Лайки" },
  reviews: { he: "ביקורות", en: "Reviews", ru: "Отзывы" },
  "website-traffic": { he: "תנועת אתר", en: "Website Traffic", ru: "Трафик сайта" },
  vk: { he: "VK", en: "VK", ru: "ВК" },
  kwai: { he: "קוואי", en: "Kwai", ru: "Kwai" },
  kick: { he: "קיק", en: "Kick", ru: "Кик" },
  shazam: { he: "שזאם", en: "Shazam", ru: "Шазам" },
  dailymotion: { he: "דיילימושן", en: "Dailymotion", ru: "Дейлимоушн" },
};

// Category name translations
export const categoryNames: Record<string, Record<Language, string>> = {
  threads: { he: "ת'רדס", en: "Threads", ru: "Threads" },
  followers: { he: "עוקבים", en: "Followers", ru: "Подписчики" },
  followerstarget: { he: "עוקבים ממוקדים (גאו)", en: "Targeted Followers (Geo)", ru: "Подписчики (Гео)" },
  likes: { he: "לייקים", en: "Likes", ru: "Лайки" },
  likestarget: { he: "לייקים ממוקדים (גאו)", en: "Targeted Likes (Geo)", ru: "Лайки (Гео)" },
  views: { he: "צפיות", en: "Views", ru: "Просмотры" },
  auto: { he: "מנויים", en: "Subscriptions", ru: "Подписки" },
  comments: { he: "תגובות", en: "Comments", ru: "Комментарии" },
  instcommentstagret: { he: "תגובות ממוקדות (גאו)", en: "Targeted Comments (Geo)", ru: "Комментарии (Гео)" },
  stories: { he: "סטוריז", en: "Stories", ru: "Сторис" },
  statistics: { he: "סטטיסטיקות", en: "Statistics", ru: "Статистика" },
  livevideo: { he: "וידאו חי", en: "Live Video", ru: "Прямой эфир" },
  mentions: { he: "אזכורים", en: "Mentions", ru: "Упоминания" },
  igtv: { he: "IGTV", en: "IGTV", ru: "IGTV" },
  reel: { he: "רילס", en: "Reels", ru: "Рилс" },
  others: { he: "אחרים", en: "Others", ru: "Другое" },
  subscribers: { he: "מנויים", en: "Subscribers", ru: "Подписчики" },
  shares: { he: "שיתופים", en: "Shares", ru: "Репосты" },
  reactions: { he: "תגובות", en: "Reactions", ru: "Реакции" },
  members: { he: "חברים", en: "Members", ru: "Участники" },
  fanpage: { he: "דף עסקי", en: "Fan Page", ru: "Фан-страница" },
  plays: { he: "השמעות", en: "Plays", ru: "Прослушивания" },
  "plays-targeted": { he: "השמעות ממוקדות", en: "Targeted Plays", ru: "Прослушивания (Гео)" },
  reposts: { he: "ריפוסטים", en: "Reposts", ru: "Репосты" },
  reshares: { he: "שיתופים מחדש", en: "Reshares", ru: "Репосты" },
  retweets: { he: "ריטוויטים", en: "Retweets", ru: "Ретвиты" },
  tweets: { he: "ציוצים", en: "Tweets", ru: "Твиты" },
  votes: { he: "הצבעות", en: "Votes", ru: "Голоса" },
  viewers: { he: "צופים", en: "Viewers", ru: "Зрители" },
  watchtime: { he: "זמן צפייה", en: "Watch Time", ru: "Время просмотра" },
  "live-stream-viewers": { he: "צופים בשידור חי", en: "Live Stream Viewers", ru: "Зрители стрима" },
  "live-viewers": { he: "צופים בשידור", en: "Live Viewers", ru: "Зрители" },
  packages: { he: "חבילות", en: "Packages", ru: "Пакеты" },
  scpackages: { he: "חבילות", en: "Packages", ru: "Пакеты" },
  soundplays: { he: "השמעות", en: "Plays", ru: "Прослушивания" },
  playlist: { he: "פלייליסט", en: "Playlist", ru: "Плейлист" },
  impressions: { he: "חשיפות", en: "Impressions", ru: "Показы" },
  "group-members": { he: "חברי קבוצה", en: "Group Members", ru: "Участники группы" },
  "5-star-rating": { he: "דירוג 5 כוכבים", en: "5-Star Rating", ru: "Рейтинг 5 звёзд" },
  targetedviews: { he: "צפיות ממוקדות", en: "Targeted Views", ru: "Просмотры (Гео)" },
  spotifystream: { he: "סטרימים", en: "Streams", ru: "Стримы" },
  spotifygeofollowers: { he: "עוקבים ממוקדים", en: "Targeted Followers", ru: "Подписчики (Гео)" },
  spotifypodcastlistener: { he: "מאזיני פודקאסט", en: "Podcast Listeners", ru: "Слушатели подкастов" },
  sporifyweblisteners: { he: "מאזיני אינטרנט", en: "Web Listeners", ru: "Веб-слушатели" },
  spotify20plays: { he: "השמעות", en: "Plays", ru: "Прослушивания" },
  tgcomments: { he: "תגובות", en: "Comments", ru: "Комментарии" },
  tgshares: { he: "שיתופים", en: "Shares", ru: "Репосты" },
  tgstories: { he: "סטוריז", en: "Stories", ru: "Сторис" },
  tgreferrals: { he: "הפניות", en: "Referrals", ru: "Рефералы" },
  tgpremiumservices: { he: "שירותי פרימיום", en: "Premium Services", ru: "Премиум услуги" },
  telegramgeofollowers: { he: "עוקבים ממוקדים", en: "Targeted Followers", ru: "Подписчики (Гео)" },
  telegramgeoviews: { he: "צפיות ממוקדות", en: "Targeted Views", ru: "Просмотры (Гео)" },
  telegramsharesgeo: { he: "שיתופים ממוקדים", en: "Targeted Shares", ru: "Репосты (Гео)" },
  tgautoservicesgeo: { he: "שירותים אוטומטיים", en: "Auto Services", ru: "Автосервисы" },
  telegrambotstart: { he: "הפעלת בוט", en: "Bot Start", ru: "Запуск бота" },
  tekegramlive: { he: "שידור חי", en: "Live Stream", ru: "Прямой эфир" },
  autotelegram: { he: "אוטומטי", en: "Auto", ru: "Авто" },
  tiktokgeofollowers: { he: "עוקבים ממוקדים", en: "Targeted Followers", ru: "Подписчики (Гео)" },
  tiktokgeoviews: { he: "צפיות ממוקדות", en: "Targeted Views", ru: "Просмотры (Гео)" },
  tiktoklive: { he: "שידור חי", en: "Live Stream", ru: "Прямой эфир" },
  tiktokothers: { he: "אחרים", en: "Others", ru: "Другое" },
  tiktokstories: { he: "סטוריז", en: "Stories", ru: "Сторис" },
  twiitertpaces: { he: "ספייסים", en: "Spaces", ru: "Спейсы" },
  twitauto: { he: "אוטומטי", en: "Auto", ru: "Авто" },
  twitvideoviews: { he: "צפיות בווידאו", en: "Video Views", ru: "Просмотры видео" },
  youtubelikestarget: { he: "לייקים ממוקדים", en: "Targeted Likes", ru: "Лайки (Гео)" },
  youtubeommentstarget: { he: "תגובות ממוקדות", en: "Targeted Comments", ru: "Комментарии (Гео)" },
  youtubeshorts: { he: "שורטס", en: "Shorts", ru: "Шортс" },
  youtubesubstargeted: { he: "מנויים ממוקדים", en: "Targeted Subscribers", ru: "Подписчики (Гео)" },
  youtubeviewsrav: { he: "צפיות", en: "Views", ru: "Просмотры" },
  ytreshfavorites: { he: "מועדפים", en: "Favorites", ru: "Избранное" },
  ytshortsgeoviews: { he: "צפיות שורטס ממוקדות", en: "Targeted Shorts Views", ru: "Просмотры шортс (Гео)" },
  ytviewshr: { he: "צפיות", en: "Views", ru: "Просмотры" },
  storyreaction: { he: "תגובות לסטורי", en: "Story Reactions", ru: "Реакции на сторис" },
};

// Common product label translations
export const labelNames: Record<string, Record<Language, string>> = {
  "עוקבים": { he: "עוקבים", en: "Followers", ru: "Подписчики" },
  "לייקים": { he: "לייקים", en: "Likes", ru: "Лайки" },
  "צפיות": { he: "צפיות", en: "Views", ru: "Просмотры" },
  "תגובות": { he: "תגובות", en: "Comments", ru: "Комментарии" },
  "שיתופים": { he: "שיתופים", en: "Shares", ru: "Репосты" },
  "מנויים": { he: "מנויים", en: "Subscribers", ru: "Подписчики" },
  "חברים": { he: "חברים", en: "Members", ru: "Участники" },
  "השמעות": { he: "השמעות", en: "Plays", ru: "Прослушивания" },
  "סטרימים": { he: "סטרימים", en: "Streams", ru: "Стримы" },
  "ריפוסטים": { he: "ריפוסטים", en: "Reposts", ru: "Репосты" },
  "ריטוויטים": { he: "ריטוויטים", en: "Retweets", ru: "Ретвиты" },
  "הצבעות": { he: "הצבעות", en: "Votes", ru: "Голоса" },
  "צופים": { he: "צופים", en: "Viewers", ru: "Зрители" },
  "חשיפות": { he: "חשיפות", en: "Impressions", ru: "Показы" },
  "דירוגים": { he: "דירוגים", en: "Ratings", ru: "Рейтинги" },
  "סטוריז": { he: "סטוריז", en: "Stories", ru: "Сторис" },
  "ביקורות": { he: "ביקורות", en: "Reviews", ru: "Отзывы" },
  "תגובות ספציפיות": { he: "תגובות ספציפיות", en: "Custom Comments", ru: "Свои комментарии" },
  "אחרים": { he: "אחרים", en: "Others", ru: "Другое" },
};

// Common description translations
export const descriptionNames: Record<string, Record<Language, string>> = {
  "עולם כולו": { he: "עולם כולו", en: "Worldwide", ru: "Весь мир" },
  "": { he: "", en: "", ru: "" },
};

// Helper to translate platform name
export function getTranslatedPlatformName(slug: string, lang: Language): string {
  return platformNames[slug]?.[lang] || platformNames[slug]?.he || slug;
}

// Helper to translate category name
export function getTranslatedCategoryName(slug: string, lang: Language): string {
  return categoryNames[slug]?.[lang] || categoryNames[slug]?.he || slug;
}

// Helper to translate label
export function getTranslatedLabel(label: string, lang: Language): string {
  return labelNames[label]?.[lang] || label;
}

// Helper to translate description
export function getTranslatedDescription(desc: string, lang: Language): string {
  return descriptionNames[desc]?.[lang] || desc;
}

// pricePerUnit translation
export function getTranslatedPricePerUnit(perUnit: string, lang: Language): string {
  const perUnitMap: Record<string, Record<Language, string>> = {
    "ל-100": { he: "ל-100", en: "per 100", ru: "за 100" },
    "ל-1000": { he: "ל-1000", en: "per 1000", ru: "за 1000" },
    "ל-500": { he: "ל-500", en: "per 500", ru: "за 500" },
    "ל-10": { he: "ל-10", en: "per 10", ru: "за 10" },
    "ל-1": { he: "ל-1", en: "per 1", ru: "за 1" },
  };
  return perUnitMap[perUnit]?.[lang] || perUnit;
}
